import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props, onRepeat) => ({
    columns: [
        {  title: 'Title of Newsletter', field: 'category', filterAndSearch: true },
        {  title: 'Sent to', field: 'subCategory', filterAndSearch: true },
        {  title: 'Date & Time', field: 'subCategory', filterAndSearch: true },
        {  
            title: 'Actions', field: '', filterAndSearch: false, 
            render: rowData => <span style={{ color: '#f58634' }} onClick={onRepeat}>Repeat</span>
        },
    ],
})

export const data = [
    {
        "category": "Category name",
        "subCategory": "1",
    },
    {
        "category": "Category name1",
        "subCategory": null,
    },
    {
        "category": "Category name2",
        "subCategory": "3",
    },
    {
        "category": "Category name2",
        "subCategory": null,
    }
];

export default tableConfig;